<template>
    <v-dialog
    v-model="globalConfirmDialog"                
    width="400"
    persistent
    >        
        <v-card>
            <v-card-title
            class="grey lighten-2 title"
            primary-title
            >
            <div>
                {{this.globalConfirmDialogData.titulo}}    <br>                 
            </div>                                             
            </v-card-title>                            
            <v-card-text>
                {{this.globalConfirmDialogData.contenido}}
            </v-card-text>                        
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                flat
                @click="closeDialog()"
            >
                Cancelar
            </v-btn>
            <v-btn                
                color="primary"
                flat                
                @click="closeOKDialog()"
            >
                Aceptar
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog> 
</template>
<script>
export default {
    name: 'globalConfirmDialog',
    data () {
      return {             
         
      }
    },
    methods:{                
        closeDialog(){
            if (this.$store.state.globalConfirmDialogData.returnMenu){
                this.navigate(1);
            }            
            this.globalConfirmDialog = false;
        },
        closeOKDialog(){
            this.$store.commit("resetOrderItems");
            if (this.$store.state.globalConfirmDialogData.returnMenu){
                this.navigate(1);
            }  
            this.globalConfirmDialog = false;
        }
    },
    computed: {     
        globalConfirmDialog:{
            get(){
                return this.$store.state.globalConfirmDialog;
            },
            set(value){
                this.$store.state.globalConfirmDialog = value;
            }
        }, 
        globalConfirmDialogData: {
            get(){
                return this.$store.state.globalConfirmDialogData;
            }
        }
    } 
}
</script>

